import { SvgIcon, SvgIconProps } from '@mui/material'

const Logo = (props: SvgIconProps) => {
  return (
    <SvgIcon color='primary' {...props} viewBox='0 0 60 60'>
      <path
        id='Path_1002'
        data-name='Path 1002'
        d='M30,60A30,30,0,1,1,60,30,30,30,0,0,1,30,60ZM30,4.444A25.556,25.556,0,1,0,55.554,30,25.556,25.556,0,0,0,30,4.444Z'
      />
      <circle
        id='Ellipse_9'
        data-name='Ellipse 9'
        cx='7.812'
        cy='7.812'
        r='7.812'
        transform='translate(22.187 22.188)'
      />
    </SvgIcon>
  )
}

export default Logo
